import furtherQuestions from '../pages/secondments/furtherQuestions';
import guidanceAndContact from '../pages/secondments/guidanceAndContact';
import { inwardSecondments, outwardSecondments } from '../pages/secondments/secondmentDetails';
import type { FormConfig } from '../types';

const formConfig: FormConfig = {
  live: false,
  id: 'secondments',
  formName: 'Secondments data return',
  title: 'Secondments data return',
  subTitle: 'Summary page',
  register: true,
  requiredFlag: true,
  listBulkUpload: true,
  listBulkUploadMode: 'direct',
  showSections: true,
  identifier: '{secondments-department}',
  sections: [
    {
      title: 'Section 1',
      slug: 'section-1',
      subsections: [
        {
          title: 'Guidance and contact details',
          slug: 'guidance-and-contact-details',
          pages: guidanceAndContact,
        },
      ],
    },
    {
      title: 'Inward secondments',
      slug: 'inward-secondments',
      subsections: [
        {
          title: 'Inward Secondments Details',
          slug: 'inward-secondments-details',
          dependsOn: 'guidance-and-contact-details',
          pages: inwardSecondments,
        },
      ],
    },
    {
      title: 'Outward Secondments Details',
      slug: 'outward-secondments',
      subsections: [
        {
          title: 'Outward Secondments Details',
          slug: 'outward-secondments-details',
          dependsOn: 'inward-secondments-details',
          pages: outwardSecondments,
        },
      ],
    },
    {
      title: 'Further Questions',
      slug: 'further-questions',
      subsections: [
        {
          title: 'Further Questions',
          slug: 'further-questions',
          dependsOn: 'outward-secondments-details',
          pages: furtherQuestions,
        },
      ],
    },
  ],
};

export default formConfig;
